// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileEmptyState-cls1_jng","cls2":"ProfileEmptyState-cls2_7ZW ProfileEmptyState-cls1_jng"};